import { Equipment } from "./equipment";
import { Operator } from "./operator";
import { ProprieteAffichee, CustomAffichage, TypePropriete } from "./proprieteAffichee";
import { Rotation } from "./rotation";
import { TypeOperation } from "./typeOperation";


export class Operation {
  operationId: number;
  typeOperationId: number;
  duree: number;
  siteId: number;
  rotationId: number;
  rotation: Rotation;
  typeOperation: TypeOperation;
  //operationEquipements: OperationEquipement[];
  equipementsFormates: string;
  equipments: Equipment[];
  operatorId: number;
  operator: Operator = null;
  timeDebut: Date;

  // Identifiant random pour différencier les différentes opérations qui sont créées lors de la création/modification d'une rotation
  randomId: number;

  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('typeOperation', 'MODALE_DONNEE_SUIVI.TYPE', 'nom'));
    tab.push(new ProprieteAffichee('operator', 'GLOBAL.OPERATOR', 'nom'));
    tab.push(new ProprieteAffichee('duree', 'GLOBAL.DURATION', '', new CustomAffichage(TypePropriete.Duration)));
    tab.push(new ProprieteAffichee('equipementsFormates', 'MODALE_DONNEE_SUIVI.EQUIPEMENTS'));
    return tab;
  }
}
